module.exports = __webpack_public_path__ + "static/media/DSC_9559_Small.ef15c458.jpg";